import { watchEffect, onScopeDispose } from "vue";

/**
 * Crea/actualiza un <script type="application/ld+json"> identificado por `id`.
 * Pasar `null`/`undefined` como data elimina el script.
 */
export function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * Composable reactivo para datos estructurados JSON-LD por página.
 * El script se elimina automáticamente cuando el componente se desmonta
 * (p. ej. al navegar a otra ruta), evitando dejar schema obsoleto en el <head>.
 *
 * @param {string} id - Identificador único del <script> (ej. "ld-vehicle").
 * @param {Object|Function} source - Objeto JSON-LD, o función que lo devuelve.
 */
export function useJsonLd(id, source) {
  watchEffect(() => {
    const data = typeof source === "function" ? source() : source;
    upsertJsonLd(id, data);
  });

  onScopeDispose(() => upsertJsonLd(id, null));
}

export default useJsonLd;
